import { COMMON_ROUTE } from "@obg/ngx.common";
import { CORE_ROUTE } from "@obg/ngx.core";

export const RESET_PASSWORD_ROUTES = [
	CORE_ROUTE.auth.resetPassword,
	CORE_ROUTE.auth.resetPasswordByEmail,
	CORE_ROUTE.auth.resetPasswordBySms,
	CORE_ROUTE.auth.resetPasswordEmailToken,
	CORE_ROUTE.auth.resetPasswordTokenOnly,
];

export const CONSENTS_ROUTES = [COMMON_ROUTE.groupCompanies, COMMON_ROUTE.privacyPolicy, COMMON_ROUTE.cookiePolicy];
